import { AbstractService } from '@uniqoders/sdk';
export default class StripeService extends AbstractService {
    /**
     * Conmfirms Stripe Checkout
     * @param data
     */
    async checkout(data) {
        return await this.request('post', this.buildPath('/checkout/confirm'), [], data);
    }
    /**
     * Retrieves Stripe Product
     * @param product
     */
    retrieveProduct(product) {
        return this.request('get', this.buildPath('/product', {
            product,
        }));
    }
    /**
     * Retrieves Stripe Countries
     * @param product
     */
    retrieveCountries(product) {
        return this.request('get', this.buildPath('/countries', {
            product,
        }));
    }
    /**
     * Retrieves Stripe Price
     * @param price
     * @param country
     */
    retrievePrice(price, country = '') {
        return this.request('get', this.buildPath('/price/{price}?country={country}', {
            price,
            country,
        }));
    }
}
